module.exports = __webpack_public_path__ + "assets/justify-to-middle-icon.d524989e.svg";